import { render, staticRenderFns } from "./IdentitySubmission.vue?vue&type=template&id=0b67333a&scoped=true"
import script from "./IdentitySubmission.vue?vue&type=script&lang=js"
export * from "./IdentitySubmission.vue?vue&type=script&lang=js"
import style0 from "./IdentitySubmission.vue?vue&type=style&index=0&id=0b67333a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67333a",
  null
  
)

export default component.exports